import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_LOAD } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { Language } from '../models/literals.model';
import { LiteralsSearchFacadeService } from './search-literals.facade.service';

@Injectable({ providedIn: 'root' })
export class LiteralsSearchService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private literalsSearchFacade: LiteralsSearchFacadeService,
  ) {}

  literalsByFilter(): Observable<QcResponseGrid> {
    const stringCode = this.literalsSearchFacade.literalCode;
    const stringLiteral = this.literalsSearchFacade.literalText;

    const url = `${this.environmentFacadeService.getEnvironment()}/rest/v1/locale-strings/findByFilter?stringCode=${stringCode}&stringLiteral=${stringLiteral}`;

    return this.http.get<QcResponseGrid>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  getAvailableLanguages(): Observable<Language[]> {
    const url = `${this.environmentFacadeService.getEnvironment()}/rest/v1/locale/findAvailableLanguages`;

    return this.http.get<Language[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  refreshCustomLiterals(): Observable<QcResponseGrid> {
    const url = `${this.environmentFacadeService.getEnvironment()}/rest/v1/locale-strings/refresh-custom`;

    return this.http.get<QcResponseGrid>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  refreshCoreLiterals(): Observable<QcResponseGrid> {
    const url = `${this.environmentFacadeService.getEnvironment()}/rest/v1/locale-strings/refresh-core`;

    return this.http.get<QcResponseGrid>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  findLiteralsByLanguage(): Observable<QcResponseGrid> {
    const language = this.literalsSearchFacade.selectedLanguage;
    const url = `${this.environmentFacadeService.getEnvironment()}/rest/v1/locale/findByLanguage?lang=${language}`;

    return this.http.get<QcResponseGrid>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }
}
